// Agenda/piezas.jsx
//
// Piezas visuales del módulo, con el mismo lenguaje que el resto del panel
// (Recintos, Usuarios, Matrículas): chips por tono, tarjeta blanca redondeada,
// filas de dato con ícono y vacío con título + texto.

import React from 'react';

const TONOS = {
  azul: 'bg-blue-50 text-primary',
  amarillo: 'bg-secondary/40 text-[#5c4300]',
  gris: 'bg-gray-100 text-gray-500',
  rojo: 'bg-red-50 text-red-700',
};

export const Chip = ({ tono = 'gris', children }) => (
  <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap ${TONOS[tono]}`}>{children}</span>
);

/** Chip a partir de un mapa { valor: [tono, texto] } (ver util.js). */
export const chipDe = (mapa, valor) => {
  const [tono, texto] = mapa[valor] || ['gris', valor || '—'];
  return <Chip tono={tono}>{texto}</Chip>;
};

export const Tarjeta = ({ children, className = '' }) => (
  <section className={`rounded-3xl bg-white border border-gray-100 shadow-[0_1px_3px_rgba(0,0,0,.04),0_8px_24px_-14px_rgba(0,0,0,.10)] ${className}`}>
    {children}
  </section>
);

export const Dato = ({ icon, label, children }) => (
  <div className="flex items-start gap-3 py-3 border-b border-gray-100 last:border-0">
    <span className="w-8 h-8 flex-shrink-0 rounded-lg bg-blue-50 text-primary flex items-center justify-center">{icon}</span>
    <div className="min-w-0">
      <p className="text-[11px] font-bold uppercase tracking-wider text-gray-500 m-0">{label}</p>
      <div className="text-sm text-gray-900 mt-0.5 break-words">{children}</div>
    </div>
  </div>
);

export const Vacio = ({ titulo, texto }) => (
  <div className="py-10 text-center">
    <p className="font-bold text-gray-900 m-0">{titulo}</p>
    {texto && <p className="text-sm text-gray-500 m-0 mt-1">{texto}</p>}
  </div>
);

/** Etiqueta de pestaña con contador, igual a la de la ficha de usuario. */
export const Etiqueta = ({ icon, texto, n }) => (
  <span className="inline-flex items-center gap-2">
    {icon} {texto}
    {n > 0 && <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-gray-100 text-gray-600 text-[11px] font-bold inline-flex items-center justify-center">{n}</span>}
  </span>
);

/** Barra de filtros blanca, igual a la de Recintos. */
export const BarraFiltros = ({ children }) => (
  <div className="flex flex-wrap items-center gap-3 p-3 mb-4 rounded-2xl bg-white border border-gray-100">{children}</div>
);

/** Botón de tres puntos de la última columna. El span corta el clic hacia la fila. */
export const claseBtnKebab =
  'w-9 h-9 inline-flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-colors';
